import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Global } from 'projects/shared-lib/src/lib/_constants/global.variables';
import { Subscription, fromEvent } from 'rxjs';
import { DataService } from '../../services/data.service';

@Component({
	selector: 'lib-material-input',
	templateUrl: './material-input.component.html',
	styleUrls: ['./material-input.component.scss'],
})
export class MaterialInputComponent implements OnInit {
	@Input() devLabel: string;
	@Input() devPlaceholder: string;
	@Output() searchcriteria = new EventEmitter<String>();
	public searchword: string;
	theme: string;
	colorChangedSubscription: Subscription;

	constructor(
		public dataService: DataService
	) {}

	ngOnInit(): void {
		this.theme = Global.Theme;
		this.colorChangedSubscription =
			this.dataService.colorChanged$.subscribe((data: any) => {
				this.theme = data;
			});
	}

	searchThis() {
		this.searchcriteria.emit(this.searchword);
	}
}
